<template>
  <z-input
    type="text"
    ref="zMoney"
    v-model="fValue"
    @blur="typing = true"
    @focus="typing = true"
    v-bind="$attrs"
    @keypress="allowedKeys($event)"
    @keyup="setSelectionRange($event)"
    style="margin-top: -3px; text-align:right;"
  />
  <!-- Original Value {{ originalValue }} -->
  <!-- <br />
    {{ typing }} -->
</template>

<script>
export default {
  name: "z-money",
  inheritAttrs: false,
  props: {
    name: String,
    originalValue: Number, // value unformat
  },
  data() {
    return {
      value: "", // untuk paparan di textbox (sudah diformat ex: x,xxxx,xxx.xx)
      typing: false,
    };
  },
  methods: {
    allowedKeys(e) {
      const keyAllowed = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
      const keyPressed = e.key;

      if (keyAllowed.includes(keyPressed)) return;
      else e.preventDefault();
    },
    setSelectionRange(e) {
      // const keyAllowed = ["arrowright", "arrowleft", "shift"];
      // const keyPressed = e.key.toLowerCase();

      // if (this.value.includes(".") && !keyAllowed.includes(keyPressed)) {
      //   let selectionActive = this.value.length - 3;
      //   console.log(
      //     this.$refs.zMoney.$refs.zInput.$refs.input.setSelectionRange(
      //       selectionActive,
      //       selectionActive
      //     )
      //   );
      // }
    },
    formatter(){
      // Create number formatter.
        let numformat = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          //style: 'currency',
          //currency: 'USD',
        });

        return numformat;
    }
  },
  computed: {
    fValue: {
      // getter
      get: function () {
        if(this.originalValue){
           return this.value || this.formatter().format(this.originalValue);
         }else{
           return '0.00';
         }
       
      },
      // setter
      set: function (newValue) {
        // let nv = parseFloat(newValue.replace(/[^\d\.]/g, ""));
        let nv = newValue.replace(',', "");
        nv = newValue.replace('.', "").replace(',', "").replace(',', "").replace(',', "").replace(',', "").replace(',', "").replace(',', "").replace(',', "");
        let len = nv.length;
        nv = nv.substring(0, len-2) + "." + nv.substring(len-2);
        // alert(nv)
        parseFloat(nv);
        if (isNaN(nv)) {
          nv = 0;
        }

        this.value = this.formatter().format(nv);
        this.$emit("update:originalValue", nv);
      },
    },
  },
};
</script>